/**
 * <NotificationDot> — la pastille « il y a du neuf » (atom).
 *
 * Un point plein, sans texte : il dit qu'il se passe quelque chose, pas combien. Quand il y a un
 * nombre à montrer, c'est `<Badge>` qu'il faut (la chip du livre, avec son libellé).
 *
 * Le liseré reprend la surface sous-jacente pour que le point se détache du glyphe qu'il recouvre.
 * Le placement appartient à l'appelant : le point se dessine là où on le met.
 */
import React from "react"
import { View } from "react-native"
import { StyleSheet } from "react-native-unistyles"

import { type SemanticColorKey } from "../../theme/tokens/colors"

export type NotificationDotProps = {
    /** Couleur du point — défaut `danger`. */
    color?: SemanticColorKey
    /** Diamètre en px — défaut 10. */
    size?: number
    /** Couleur du liseré — défaut `surface-raised`, la surface du header. */
    ringColor?: SemanticColorKey
    testID?: string
}

export function NotificationDot(props: NotificationDotProps) {
    const { color = "danger", size = 10, ringColor = "surface-raised", testID } = props

    return <View testID={testID} style={styles.dot(color, size, ringColor)} pointerEvents="none" />
}

const styles = StyleSheet.create((theme) => ({
    dot: (color: SemanticColorKey, size: number, ringColor: SemanticColorKey) => ({
        width: size,
        height: size,
        borderRadius: size / 2,
        backgroundColor: theme.colors[color],
        // Proportion du point, pas une décision de gabarit : le liseré vaut un cinquième du disque.
        borderWidth: Math.max(1, Math.round(size / 5)),
        borderColor: theme.colors[ringColor],
    }),
}))
